import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import AdminLayout from "@/components/AdminLayout";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Agence from "@/pages/Agence";
import Syndic from "@/pages/metiers/Syndic";
import SyndicEnLigne from "@/pages/metiers/SyndicEnLigne";
import ASL from "@/pages/metiers/ASL";
import Expertise from "@/pages/metiers/Expertise";
import AGVisio from "@/pages/metiers/AGVisio";
import Actualites from "@/pages/Actualites";
import ArticleDetail from "@/pages/ArticleDetail";
import Lexique from "@/pages/Lexique";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminArticles from "@/pages/admin/AdminArticles";
import AdminLexique from "@/pages/admin/AdminLexique";
import AdminFaq from "@/pages/admin/AdminFaq";
import AdminContacts from "@/pages/admin/AdminContacts";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster
          position="top-right"
          toastOptions={{
            style: { background: "#0F172A", color: "#F9F8F6", border: "1px solid #B8935A" },
          }}
        />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/notre-agence" element={<Agence />} />
            <Route path="/metiers/syndic" element={<Syndic />} />
            <Route path="/metiers/syndic-en-ligne" element={<SyndicEnLigne />} />
            <Route path="/metiers/gestionnaire-asl" element={<ASL />} />
            <Route path="/metiers/expertise" element={<Expertise />} />
            <Route path="/metiers/ag-visioconference" element={<AGVisio />} />
            <Route path="/actualites" element={<Actualites />} />
            <Route path="/actualites/:slug" element={<ArticleDetail />} />
            <Route path="/lexique" element={<Lexique />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<AdminLayout />}>
            <Route path="/admin" element={<AdminArticles />} />
            <Route path="/admin/articles" element={<AdminArticles />} />
            <Route path="/admin/lexique" element={<AdminLexique />} />
            <Route path="/admin/faq" element={<AdminFaq />} />
            <Route path="/admin/contacts" element={<AdminContacts />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
